// supervisor-ticket-projection.ts
//
// Loads tickets from `<repo>/.avatar/tickets/*.json` (git-versioned, spec
// §5.1) and combines them with MissionStore's `tickets` map (runtime status,
// mission-state-reducer.ts) into scheduler.ts's `SchedulerProjection`. A
// ticket with no entry yet in the mission state defaults to "todo" (freshly
// seeded, never dispatched) — mirrors scheduler.ts's own `statusOf` default.
import { promises as fs } from "node:fs";
import { join } from "node:path";
import type { SchedulerProjection, TicketRuntimeStatus } from "./scheduler.js";
import { type Ticket, TicketSchema } from "./schemas/ticket-schema.js";

export async function loadTicketsFromRepo(repoDir: string): Promise<Ticket[]> {
  const dir = join(repoDir, ".avatar", "tickets");
  let entries: string[];
  try {
    entries = (await fs.readdir(dir)).filter((f) => f.endsWith(".json"));
  } catch {
    return [];
  }
  const tickets: Ticket[] = [];
  for (const file of entries.sort()) {
    const raw = await fs.readFile(join(dir, file), "utf8");
    tickets.push(TicketSchema.parse(JSON.parse(raw)));
  }
  return tickets;
}

export function buildSchedulerProjection(
  tickets: Ticket[],
  missionTicketStatus: Record<string, string>,
): SchedulerProjection {
  const ticketStatus: Record<string, TicketRuntimeStatus> = {};
  for (const ticket of tickets) {
    ticketStatus[ticket.id] = (missionTicketStatus[ticket.id] as TicketRuntimeStatus) ?? "todo";
  }
  return { tickets, ticketStatus };
}
